import { useEffect } from 'react';

export const BlockquoteElement = props => {
	// Hooks
	useEffect(() => {
		// logger.log('BlockquoteElement: ', props);
	}, []);

	// Render
	return (
		<blockquote>
			<h4 className='text-xl font-semibold lg:text-2xl font-light italic'>{props.children}</h4>
		</blockquote>
	);
};
// Docs
// https://shiki.matsu.io/
